import { withPublicHOC } from '../../hoc';

const TermsAndConditions = () => {
  return <h1>TermsAndConditions</h1>;
};

export default withPublicHOC(TermsAndConditions);
